<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <MonitObserveTaskList></MonitObserveTaskList>
    </template>
  </BasicLayout>
</template>
<script>
import BasicLayout from '../../layouts/BasicLayout';
import MonitObserveTaskList from '../../components/observeconfig/monitTask/MonitObserveTaskList';

export default {
  name: 'MonitObservePage',
  components: {
    BasicLayout,
    MonitObserveTaskList
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('Observe.observeManage')}/${this.$t('Observe.monitorTrack')}`
      }
    };
  }
};
</script>